export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <>
      <section className="px-4 pb-16 md:px-6 md:pb-24">
        <div className="mx-auto max-w-7xl overflow-hidden rounded-3xl bg-primary-700 px-6 py-12 md:px-12 md:py-16">
          <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
            <div>
              <p className="text-sm font-semibold tracking-widest text-primary-100">一起理性吃瓜</p>
              <h2 className="mt-3 font-heading text-3xl font-bold leading-tight text-white md:text-4xl">
                从一份入门手册开始，
                <br />
                发现更有条理的围观方式
              </h2>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <a
                href="#howto"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-white px-6 py-3 text-base font-semibold text-primary-800 transition-colors hover:bg-primary-50 whitespace-nowrap"
              >
                马上看入门
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#guides"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-6 py-3 text-base font-semibold text-white ring-1 ring-inset ring-primary-400 transition-colors hover:bg-primary-500 whitespace-nowrap"
              >
                进攻略合集
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-background-200 bg-background-100/70">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-4 py-10 sm:flex-row sm:items-center md:px-6">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
              <i className="ri-eye-line text-xl"></i>
            </span>
            <span className="font-heading text-lg font-semibold text-foreground-950">海角吃瓜</span>
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-foreground-500">
            <a href="#feed" className="transition-colors hover:text-primary-700 whitespace-nowrap">快讯</a>
            <a href="#howto" className="transition-colors hover:text-primary-700 whitespace-nowrap">怎么玩</a>
            <a href="#guides" className="transition-colors hover:text-primary-700 whitespace-nowrap">攻略合集</a>
            <a href="#rules" className="transition-colors hover:text-primary-700 whitespace-nowrap">规则</a>
            <a href="#faq" className="transition-colors hover:text-primary-700 whitespace-nowrap">问答</a>
          </div>
          <p className="text-xs text-foreground-400">
            © {year} 海角吃瓜 · 本页为静态展示内容
          </p>
        </div>
      </footer>
    </>
  );
}